// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"38251c79","453":"abdb07a6","667":"fae0c811","977":"96dfa038"}[chunkId] + ".chunk.js";
};